import { UnleashClient } from 'unleash-proxy-client'

const url = process.env.VUE_APP_UNLEASH_PROXY_URL
const clientKey = process.env.VUE_APP_UNLEASH_CLIENT_KEY
const appName = process.env.VUE_APP_UNLEASH_APP_NAME
const environment = process.env.VUE_APP_UNLEASH_VUE_APP_ENVIRONMENT
const instanceId = process.env.VUE_APP_UNLEASH_INSTANCE_ID

let client = {
  isEnabled: () => false,
  on: () => {},
  start: () => {}
}

if (url && clientKey) {
  try {
    client = new UnleashClient({
      url,
      clientKey,
      appName,
      environment,
      instanceId
    })
    client.start().then(
      () => {
        console.log('Unleash client started')
      },
      (error) => {
        console.log('Unleash client failed to start', error)
      }
    )
  } catch (e) {
    console.log(e)
  }
}

export default client
